<script lang="ts">
	/** Borderless, icon-only action button for table rows. */
	export let icon: string; // Font Awesome class, e.g. 'fa-pen'
	export let label: string; // accessible label + tooltip (no visible text)
	export let danger = false; // destructive actions hover red
</script>

<button
	type="button"
	title={label}
	aria-label={label}
	on:click
	class="p-1.5 rounded text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors {danger
		? 'hover:text-red-600 dark:hover:text-red-400'
		: 'hover:text-gray-700 dark:hover:text-gray-200'}"
>
	<i class="fa-solid {icon}"></i>
</button>
